// extracted by mini-css-extract-plugin
export default {"div":"WeatherCard_div__ASj1r","h2":"WeatherCard_h2__qduhf"};